import { PulseModule, RUMFilter, stringToRegExp, TrackerSharedConfigurations } from '@pulse/common';
import { trackerProviders } from './factory';
import { trackerSharedConfigs } from './tracker.configuration';

function parseRUMName(filters: RUMFilter[]) {
    for (const filter of filters) {
        if (typeof filter === 'object' && Array.isArray(filter.name)) {
            for (let i = 0; i < filter.name.length; i++) {
                const name = filter.name[i];

                if (typeof name === 'string' && name.startsWith('/')) {
                    const regexp = stringToRegExp(name);

                    if (regexp instanceof RegExp) {
                        filter.name[i] = regexp;
                    }
                }
            }
        }
    }
}

function normalizeRUMConfig(config: Required<TrackerSharedConfigurations>) {
    config.rumReport = config.rumReport || [];
    config.rumReportOnce = config.rumReportOnce || [];

    parseRUMName(config.rumReport);
    parseRUMName(config.rumReportOnce);
}

function buildConfig(
    userConfig: Partial<TrackerSharedConfigurations>,
): Required<TrackerSharedConfigurations> {
    const config: Required<TrackerSharedConfigurations> = {
        ...trackerSharedConfigs,
        ...userConfig,
    };

    normalizeRUMConfig(config);

    return config;
}

export const TrackerSharedModule = new PulseModule<TrackerSharedConfigurations>()
    .provide(trackerProviders)
    .beforeInit(buildConfig);
